/**
 * Loading skeleton rows for the notifications dropdown.
 */
import * as React from 'react';
import { NOTIFICATION_SKELETON_ROWS } from './notification-configs';

/** Props for {@link NotificationsSkeleton}. */
interface NotificationsSkeletonProps {
  rows?: number;
}

/** Placeholder rows while the inbox query is loading. */
export const NotificationsSkeleton: React.FC<NotificationsSkeletonProps> = ({
  rows = NOTIFICATION_SKELETON_ROWS,
}) => {
  const rowIds = Array.from({ length: rows }, (_, i) => `notif-skel-${i}`);

  function renderSkeletonRow(id: string): React.ReactNode {
    return (
      <div key={id} className="notifications-dropdown-skeleton-row">
        <div className="notifications-dropdown-skeleton-avatar animate-shimmer" />
        <div className="notifications-dropdown-skeleton-lines">
          <div className="notifications-dropdown-skeleton-line animate-shimmer w-3/4" />
          <div className="notifications-dropdown-skeleton-line animate-shimmer w-5/6" />
          <div className="notifications-dropdown-skeleton-line animate-shimmer w-1/3" />
        </div>
      </div>
    );
  }

  return (
    <div className="notifications-dropdown-skeleton-list" aria-hidden>
      {rowIds.map(renderSkeletonRow)}
    </div>
  );
};
